<template>
  <div>
    <v-layout>
      <v-flex xs12 class="ma-2">
        <v-stepper v-model="e1">
          <div>
            <h1 class="text-center font-weight-light">Redhead Supports New Hire Documents Test</h1>
            <p class="text-center caption">These documents need to be filled out before you're able to be scheduled</p>
          </div>
          <v-stepper-header dark>
            <v-stepper-step
                editable
                step="1"
            >
              Contact Information
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                step="2"
                editable
            >
              Employement Agreement
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                editable
                step="3"
            >
              Document 3
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                editable
                step="4"
            >
              Document 4
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                editable
                step="5"
            >
              Document 5
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step editable step="6">
              Document 6
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step editable step="7">
              Document 7
            </v-stepper-step>

            <v-divider></v-divider>

          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card
                  class="mb-12 grey lighten-4"
                  height="auto"

              >
                <v-card-title class="font-weight-regular red--text text-center pa-6">Please fill out the information below</v-card-title>
                <v-layout row wrap>
                  <v-flex xs4>
                    <v-text-field class="pa-6" label="First Name"></v-text-field>
                  </v-flex>

                  <v-flex xs4>
                    <v-text-field class="pa-6" label="Last Name"></v-text-field>
                  </v-flex>

                  <v-flex xs4>
                    <v-text-field class="pa-6" label="Email"></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field class="pa-6" label="Address"></v-text-field>
                  </v-flex>

                  <v-flex xs2>
                    <v-text-field class="pa-6" label="City"></v-text-field>
                  </v-flex>

                  <v-flex xs2>
                    <v-text-field class="pa-6" label="State"></v-text-field>
                  </v-flex>

                  <v-flex xs2>
                    <v-text-field class="pa-6" label="Zip"></v-text-field>
                  </v-flex>

                  <v-flex xs6>
                    <v-text-field class="pa-6" label="Phone Number"></v-text-field>
                  </v-flex>

                  <v-flex xs6>
                    <v-text-field class="pa-6" label="Phone Provider"></v-text-field>
                  </v-flex>

                  <v-flex xs6>
                    <v-select class="pa-6" label="Employement Position"></v-select>
                  </v-flex>
                </v-layout>
              </v-card>

              <v-btn
                  color="primary"
                  @click="e1 = 2"
                  class="mb-10"
              >
                Continue
              </v-btn>

              <v-btn
                  text
                  class="mb-10"
              >
                Cancel
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                  class="mb-12"
                  height="auto"

              >
                <v-img src="/RHS.png" :aspect-ratio="16/9" width="140" height="150"></v-img>

                <h1 class="text-center font-weight-light mb-16">Employement Agreement</h1>

                <div>
                  <span>This Employment Agreement (“Agreement”) is between and among Redhead Support-UT LLC, a Utah corporation (the “Company”), and </span><v-text-field class="input" label="Enter Your Full Name"></v-text-field>
                  (“Employee”).
                </div><br>

                <div>
                  In consideration of the Company’s employment or continued employment of Employee, the mutual promises and covenants set forth herein,
                  and other good and valuable consideration, the adequacy of which is hereby acknowledged, the Company and Employee (collectively, the “Parties,”
                  or individually, ‘Party”), agree as follows:
                </div><br>

                <div class="ml-6">
                        <span>1.      Employment.      The Company agrees to employ Employee, and Employee agrees to be employed by the Company, on a part-time hourly basis
                        in the position of</span> <v-text-field class="input" label="Enter Position"></v-text-field>. <span>Employee understands that the first 90 days of employment are an introductory and training period
                        and the Company reserves the right to terminate the employees at its discretion at any time for any reason during that time.  If an employee no-calls
                        or no-shows at any time during the first 90 days the employee will be terminated.</span>
                </div><br>

                <div class="ml-6">
                  2.      At-Will Employment.      The Parties acknowledge and agree that the employment relationship between Employee and the Company is “at-will.” As an
                  at-will employee, Employee is free to terminate the employment relationship with the Company at any time, with or without cause and with or without advance
                  notice. Similarly, the Company is free to terminate Employee’s employment with the Company at any time, with or without cause and with or without advance
                  notice. Nothing in this Agreement is intended to create, or shall be construed as creating, an obligation on Employee’s part to work for the Company for any
                  fixed period of time, or an obligation on the Company’s part to employ Employee for any specific duration, or to terminate Employee only for good cause or only
                  after warnings have been given or progressive discipline has been imposed.
                </div><br>

                <div class="ml-6">
                  <span>3.      Duties.       While employed by the Company as a </span><v-text-field class="input" label="Position"></v-text-field>, <span>Employee shall perform the services described in the job description and
                        policies and procedures manual specific to their position, all tasks, functions and responsibilities incidental or inherent thereto, and all additional duties
                        assigned to Employee by Employee’s supervisor or the Company’s senior management (collectively, the “Services”). Employee shall at all times faithfully, diligently
                        and conscientiously perform all of the duties that reasonably may be required of and from Employee pursuant to the express and implied terms of this Agreement
                        in a timely, professional, competent, and ethical manner, and in accordance with all applicable policies, protocols, rules, regulations and laws. Employee is
                        expected to work no more than 29 hours per week performing such Services.</span>
                </div><br>

                <div class="ml-6">
                  <span>4.      Compensation.      Employee’s pay shall be </span><v-text-field class="input" prefix="$"></v-text-field> <span>per hour less applicable tax withholdings and deductions required by law or authorized by Employee,
                        payable in equal bi-weekly payments in accordance with the Company’s regular payroll policies and practices. Employee’s pay is intended to compensate Employee for all
                        hours worked. Employee is a non-exempt employee for purposes of federal and state wage and hour laws and therefore will be entitled to overtime pay for hours worked in
                        excess of 40 in a workweek. The Company may adjust Employee’s compensation, in writing, without formally amending this Agreement.</span>
                </div><br>

                <div class="ml-6">
                  5.      Benefits.      Employee shall not be eligible to participate in those Company-sponsored benefit programs that are available to other employees.
                </div><br>

                <div class="ml-6">
                  6.      Compensation upon Termination.
                  (a)      Upon the termination of Employee’s employment with the Company, Employee shall be paid his/her accrued pay through the date of termination but shall not be entitled to any severance pay.

                </div><br>

                <div class="ml-6">
                  7.      Obligation to Execute Agreement Regarding Confidential Information Covenant, Ownership of Inventions Covenant, Non-competition Covenant, Customer and Employee
                  Non-Solicitation Covenants, and Acknowledgement of At-will Employment.      As a condition of employment with the Company, Employee shall be required to execute the Company’s Agreement Regarding
                  Confidential Information Covenant, Ownership of Inventions Covenant, Non-competition Covenant, Customer and Employee Non-Solicitation Covenants, and Acknowledgement of At-will Employment that
                  currently is being used by the Company, as well as any subsequent versions of that Agreement that may be prepared hereafter.
                </div><br>

                <div class="ml-6">
                  8.      Warranties.      Employee represents, warrants and covenants that (a) Employee has the full power and authority to enter into this Agreement and to
                  perform his/her duties and obligations hereunder; and (b) Employee’s agreement to perform the work required of him/her by this Agreement does not violate any
                  understanding or agreement with any previous employer or other third party, and does not require any consents, approvals or immunities not yet obtained.
                </div><br>

                <div class="ml-6">
                  9.      Effective Date.      This Agreement shall take effect and be binding upon the Parties at such time as both Parties have signed the Agreement.
                </div><br>

                <div class="ml-10">
                  10. Miscellaneous Provisions.
                  (a)      Severability.      If any provision in this Agreement is held invalid or unenforceable by a court of competent jurisdiction, such provision shall be fully severable, and the invalidity or unenforceability of that provision shall not affect the validity or enforceability of the remaining provisions, and the remainder of the Agreement shall be enforced to the greatest extent possible.
                </div><br>

                <div class="ml-10">
                  (b)      Successors and Assigns.      Employee acknowledges that the Company has entered into this Agreement on the basis of the particular abilities of Employee.
                  The Company shall be entitled to assign, sell, transfer, or delegate, whether voluntarily or involuntarily, by operation of law or otherwise, this Agreement and
                  any of its rights or obligations of this Agreement, but Employee shall not have the right to, and shall not, assign, sell, transfer, or delegate, whether voluntarily
                  or involuntarily, by operation of law or otherwise, this Agreement or any of his rights or obligations under this Agreement without the prior written consent of the Company.
                  Except as provided herein, any purported assignment, sale, transfer, or delegation by Employee, except as permitted herein, shall be null and void. Subject to the foregoing,
                  this Agreement shall be binding upon and shall inure to the benefit of the Parties and their respective successors and permitted assigns.
                </div><br>

                <div class="ml-10">
                  (c)      Governing Law.      The validity, interpretation, enforceability, and performance of this Agreement shall be governed by and construed in accordance with the laws of the state of
                  Utah, without regard to its conflicts of law or choice of law rules or principles.
                </div><br>

                <div class="ml-10">
                  (d)      Jurisdiction and Venue.      The Parties hereby agree that the sole and exclusive jurisdiction and venue for any litigation arising from or relating
                  to this Agreement shall be in Salt Lake County, Utah. Thus, any action to enforce, interpret or construe this Agreement, to seek to recover for its breach, or
                  to assert any claim arising from the employment relationship between the Company and Employee, or the termination thereof, must be brought in an appropriate
                  federal or state court located in Salt Lake County, Utah. The Parties stipulate to the jurisdiction and venue of such court.
                </div><br>

                <div class="ml-10">
                  (e)      Waiver.      A Party’s failure to enforce any provision of this Agreement or waiver of any breach of the Agreement in one instance shall not constitute
                  a waiver of the other Party’s obligation to comply with the provision in the future and does not limit the Party’s right to enforce the provision, or to take legal action to
                  remedy or recover for the breach in the future.
                </div><br>

                <div class="ml-10">
                  (f)      Entire Agreement.      This Agreement is the final, complete and exclusive agreement of the Parties with respect to the subject matter hereof and supersedes and merges
                  all prior or contemporaneous representations, discussions, proposals, negotiations, conditions, communications and agreements, whether written or oral, between the Parties relating to
                  the subject matter hereof and all past courses of dealing or industry custom. No modification of or amendment to this Agreement shall be effective unless it is in writing and signed by
                  each of the Parties.
                </div><br>

                <div class="ml-10">
                  (g)      Attorney Fees and Costs.      In the event that either Party to this Agreement commences an action to enforce the terms of this Agreement, or to seek injunctive relief or damages
                  for its breach, the prevailing party in such action shall be entitled to recover from the non-prevailing party his or its attorney fees and costs incurred therein.
                </div><br>

                <div class="ml-10">
                  (h)      Counterparts.      This Agreement may be executed in one or more counterparts, each of which shall be deemed to be an original, but all of which together will constitute one and the
                  same agreement. A Party’s signature delivered by facsimile, email or electronic signature shall be enforceable as an original signature.
                </div><br>

                <div class="ml-10">
                  (i)      Unacceptable Conduct.      While not intended to be an all-inclusive list, the following are examples of inappropriate conduct that may result in disciplinary action, up to and including,
                  termination of Employee’s employment:
                </div><br>

                <div class="ml-16">
                  <ol>
                    <li>Abuse, exploitation, neglect, or maltreatment of an individual receiving supports from Redhead Supports.</li>
                    <li>Theft or inappropriate removal or possession of company property.</li>
                    <li>Falsification of records and/or timesheets.</li>
                    <li>Working under the influence of alcohol or other mood-altering substances.</li>
                    <li>Possession, distribution, sale, transfer, or use of alcohol, illegal drugs, or medications that impair ability to perform duties in the work place, while on duty, or while operating vehicles or equipment.</li>
                    <li>Fighting or threatening violence in the work place.</li>
                    <li>Negligence or improper conduct leading to damage of employer-owned or client-owned property.</li>
                    <li>Using company computers to view or distribute pornography.</li>
                    <li>Viewing or distributing pornography while on shift.</li>
                    <li>Violation of safety or health rules.</li>
                    <li>Unlawful harassment or discrimination.</li>
                    <li>Possession of dangerous or unauthorized materials, such as explosives or firearms, in the work place.</li>
                    <li>Insubordination (i.e., refusal to follow directives from management and/or lack of adherence to company policies and procedures).</li>
                    <li>Excessive absenteeism or any absence without notice.</li>
                    <li>Violation of company policies.</li>
                    <li>Unsatisfactory performance or conduct.</li>
                  </ol>
                </div><br>
                <div>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <span>Date: </span>
                      <v-menu
                          offset-y
                          max-width="290px"
                          min-width="290px"

                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field :value="newDate" label="Date" v-on="on"  prepend-icon="event"></v-text-field>
                        </template>
                        <v-date-picker v-model="newDate" scrollable></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span>Redhead Support HR Signature: </span>
                      <img v-if="newEnergySignature !== ''"  :src="newEnergySignature" style="width:200px;position:absolute;right: 450px;">
                      <v-text-field
                          label="Click here to sign"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span>Date: </span>
                      <v-menu
                          offset-y
                          max-width="290px"
                          min-width="290px"

                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field :value="newDate" label="Date" v-on="on"  prepend-icon="event"></v-text-field>
                        </template>
                        <v-date-picker v-model="newDate" scrollable></v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <span>Employee Signature: </span>
                      <img v-if="newEnergySignature !== ''"  :src="newEnergySignature" style="width:200px;position:absolute;right: 450px;">
                      <v-text-field
                          @click="signaturePop()"
                          label="Click here to sign"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>


                <v-dialog v-model="signaturepop" max-width="50%">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Signature Pad</span>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="signaturepop = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <div id="signaturePad">
                      <VueSignaturePad
                          width="700px"
                          height="300px"
                          ref="signaturePad"
                          :options="{onBegin: () => {$refs.signaturePad.resizeCanvas()}}"
                      />
                    </div>
                    <v-divider></v-divider>
                    <v-card-actions class="mr-12">
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1 white--text"  @click="save">Save</v-btn>
                      <v-btn @click="undo"> Undo</v-btn>
                      <v-btn  @click="clear"> Clear</v-btn>
                      <v-btn color="red darken-1 white--text" @click="cancel">Cancel</v-btn>
                    </v-card-actions>

                  </v-card>
                </v-dialog>

              </v-card>



              <v-btn
                  color="primary"
                  @click="e1 = 3"
              >
                Continue
              </v-btn>

              <v-btn text>
                Cancel
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card
                  class="mb-12"
                  height="200px"
              ></v-card>

              <v-btn
                  color="primary"
                  @click="e1 = 4"
              >
                Continue
              </v-btn>

              <v-btn text>
                Cancel
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="4">
              <v-card
                  class="mb-12"
                  height="200px"
              ></v-card>

              <v-btn
                  color="primary"
                  @click="e1 = 5"
              >
                Continue
              </v-btn>

              <v-btn text>
                Cancel
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="5">
              <v-card
                  class="mb-12"
                  height="200px"
              ></v-card>

              <v-btn
                  color="primary"
                  @click="e1 = 6"
              >
                Continue
              </v-btn>

              <v-btn text>
                Cancel
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="6">
              <v-card
                  class="mb-12"
                  height="200px"
              ></v-card>

              <v-btn
                  color="primary"
                  @click="e1 = 7"
              >
                Continue
              </v-btn>

              <v-btn text>
                Cancel
              </v-btn>
            </v-stepper-content>

            <v-stepper-content step="7">
              <v-card
                  class="mb-12"
                  height="200px"
              ></v-card>

              <v-btn
                  color="primary"
                  @click="e1 = 8"
              >
                Continue
              </v-btn>

              <v-btn text>
                Cancel
              </v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>
    </v-layout>
    <Foot/>
  </div>
</template>
<script>
import Foot from '../components/Footer'

export default {
  components: {
    Foot,
  },
  data: function() {
    return {
      e1: 1,
      signaturepop: false,
      newEnergySignature: "",
      signaturePad: "",
    }
  },
  methods: {
    signaturePop() {
      this.signaturepop = true;
      if(this.$refs.signaturePad !== undefined){
        this.$refs.signaturePad.clearSignature();
      }
    },

    signaturePop2() {
      this.signaturepop2 = true;
      if(this.$refs.signaturePad2 !== undefined){
        this.$refs.signaturePad2.clearSignature();
      }
    },

    signaturePop3() {
      this.signaturepop3 = true;
      if(this.$refs.signaturePad3 !== undefined){
        this.$refs.signaturePad3.clearSignature();
      }
    },

    signaturePop4() {
      this.signaturepop4 = true;
      if(this.$refs.signaturePad4 !== undefined){
        this.$refs.signaturePad4.clearSignature();
      }
    },

    signaturePop5() {
      this.signaturepop5 = true;
      if(this.$refs.signaturePad5 !== undefined){
        this.$refs.signaturePad5.clearSignature();
      }
    },

    onBegin() {
      console.log('=== Begin ===');

    },
    onEnd() {
      console.log('=== End ===');
    },

    undo() {
      if(this.$refs.signaturePad !== undefined){
        this.$refs.signaturePad.undoSignature();
      }
      if(this.$refs.signaturePad2 !== undefined){
        this.$refs.signaturePad2.undoSignature();
      }
      if(this.$refs.signaturePad3 !== undefined){
        this.$refs.signaturePad3.undoSignature();
      }
      if(this.$refs.signaturePad4 !== undefined){
        this.$refs.signaturePad4.undoSignature();
      }
      if(this.$refs.signaturePad5 !== undefined){
        this.$refs.signaturePad5.undoSignature();
      }
    },
    clear(){
      if(this.$refs.signaturePad !== undefined){
        this.$refs.signaturePad.clearSignature();
      }
      if(this.$refs.signaturePad2 !== undefined){
        this.$refs.signaturePad2.clearSignature();
      }
      if(this.$refs.signaturePad3 !== undefined){
        this.$refs.signaturePad3.clearSignature();
      }
      if(this.$refs.signaturePad4 !== undefined){
        this.$refs.signaturePad4.clearSignature();
      }
      if(this.$refs.signaturePad5 !== undefined){
        this.$refs.signaturePad5.clearSignature();
      }
    },
    cancel(){
      this.signaturepop = false;
      this.signaturepop2 = false;
      this.signaturepop3 = false;
      this.signaturepop4 = false;
    },
    save() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

      console.log(isEmpty);
      this.newEnergySignature = data;
      this.signaturepop = false;
    },
    save2() {
      const { isEmpty, data } = this.$refs.signaturePad2.saveSignature();

      console.log(isEmpty);
      this.newCustomerInitial = data;
      this.signaturepop2 = false;
    },
    save3() {
      const { isEmpty, data } = this.$refs.signaturePad3.saveSignature();

      console.log(isEmpty);
      this.newRepInitial = data;
      this.signaturepop3 = false;
    },
    save4() {
      const { isEmpty, data } = this.$refs.signaturePad4.saveSignature();

      console.log(isEmpty);
      this.newRepName = data;
      this.signaturepop4 = false;
    },

    save5() {
      const { isEmpty, data } = this.$refs.signaturePad5.saveSignature();

      console.log(isEmpty);
      this.newCustomerName = data;
      this.signaturepop5 = false;
    },

  },

};
</script>
<style>
#image {
  margin-left:auto;
  margin-right:auto;
}


#signaturePad > div,
#signaturePad2 > div,
#signaturePad3 > div,
#signaturePad4 > div,
#signaturePad5 > div{
  margin: auto;
  border: 1px solid #000;
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
  radial-gradient(circle at top left, #000, #000);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
.v-text-field.input{
  width: 15%;
  max-width: 15%;
  display: inline-block;
}
</style>
